import React from "react";
import { Button } from "react-bootstrap";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../../components/grid-container/GridContainer";
import trophyStar from '../../../../../styles/img/tropystar.png';
import trophyCup from '../../../../../styles/img/Trophy-cup.png';


export const GoalAchievedMessage = () => {
    return (
        <>
            <div className="sb-goal-achieved-msg">
                <UiContentCol>
                    <UiSingleRow>
                        <UiCol lg="8">
                            <h3>Congratulations</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                tempor incididunt ut ero labore et dolore magna aliqua. </p>
                            <Button className="sb-geen-btn" >Book Now</Button>
                        </UiCol>
                        <UiCol lg="4" className="sb-goal-achieved-msg__trophies">
                            <img src={trophyCup} />
                            <img src={trophyStar} />
                        </UiCol>
                    </UiSingleRow>

                </UiContentCol>
            </div>
        </>
    )
}